import { Button, Text } from '@chakra-ui/react';
import type { CardProps } from '@ui/components/Card';
import { Card } from '@ui/components/Card';
import { useUseYourTokenDrawer } from '@ui/components/useYourTokenDrawer';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { useTranslations } from '@ui/i18n';
import type { FC } from 'react';
import React from 'react';

import { useLcroProtocols } from './utils';

export const UseLcroCard: FC<CardProps> = (props) => {
  const t = useTranslations();
  const coinMode = useCoinMode();
  const lcroProtocols = useLcroProtocols();

  return (
    <Card
      display="flex"
      minH="74px"
      p={{
        base: '10px 10px 16px',
        desktop: '10px 16px 16px',
      }}
      gap="10px"
      mx="0"
      justifyContent="space-between"
      cursor="pointer"
      bgImage="url('/images/pattern-3.png')"
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPos="center -152px"
      onClick={() => {
        useUseYourTokenDrawer.getState().onOpen({
          title: t('Use your {coin}', {
            coin: COIN_MODE[coinMode].liquidName,
          }),
          protocols: lcroProtocols,
        });
      }}
      {...props}
    >
      <Text>
        {t('View all projects & protocols {br} supporting {coin}', {
          coin: COIN_MODE[coinMode].liquidName,
          br: () => <br />,
        })}
      </Text>
      <Button variant="secondary" size="sm">
        {t('View')}
      </Button>
    </Card>
  );
};
